export default __webpack_public_path__ + "static/media/e-SIP-logo.91069a83.png";